<template>
  <div>
    <div v-if="searchable">
      <div class="pt-3 px-3 row justify-content-between">
        <div class="col-3">
          <slot name="search-left"></slot>
        </div>
        <div class="col-6 text-center">
          <CInput
            type="search"
            v-model="searchValue"
            @input="search"
            :placeholder="searchPlaceholder"
            addInputClasses="pl-5"
            class="iconSearchPlaceholder-table text-left"
          >
          </CInput>
        </div>
        <div class="col-3 text-right">
          <slot name="search-right"></slot>
        </div>
      </div>

      <div class="separator"></div>
    </div>

    <div class="px-3 py-2 row justify-content-between">
      <div class="col-4">
        <slot name="filters-left"></slot>
      </div>
      <div class="col-4 text-center">
        <slot name="filters-center"></slot>
      </div>
      <div class="col-4 text-right">
        <slot name="filters-right"></slot>
      </div>
    </div>

    <div class="px-3 d-flex action-filters-area align-items-center">
      <CRow v-if="selectable">
        <CCol v-if="selectionType == 'checkbox'">
          <div class="pt-1" v-if="selectable && selectionType == 'checkbox'">
            <CInputCheckbox custom @update:checked="selectAllRegisters" />
          </div>
        </CCol>
        <CCol>
          <slot name="select-actions"></slot>
        </CCol>
      </CRow>
    </div>
    <CCardBody class="dataTable__body p-0 data_table_transactions">
      <CDataTable
        :items="registersData"
        :fields="headersData"
        :table-filter="{ external: true, lazy: true }"
        items-per-page-select
        @row-clicked="() => {}"
        hover
        :loading="loading"
      >
        <template #loading>
          <div class="d-flex justify-content-center align-items-center dataTable__loading">
            <CSpinner class="my-3" color="primary" />
          </div>
        </template>

        <!-- eslint-disable-next-line -->
        <template #select="{ item }">
          <td @click.stop>
            <CInputCheckbox
              v-if="selectionType == 'checkbox'"
              :checked.sync="item._selected"
              @update:checked="selectRegister"
              class="text-center checkboxTable"
              custom
            />
            <CInputRadio
              v-if="selectionType == 'radio'"
              :checked.sync="item._selected"
              name="table-radio"
              @update:checked="selectRegisterRadio(item)"
              class="text-center checkboxTable"
              custom
            />
          </td>
        </template>

        <template v-for="field in headers" v-slot:[field.key]="item">
          <slot :name="field.key" :item="item.item">
            <!-- eslint-disable-next-line -->
            <td>{{ item.item[field.key] }}</td>
          </slot>
        </template>

        <template #expand-column="{item, index}">
          <td class="text-center" style="min-width: 150px" @click="toggleDetails(item, index)">
            <span>
              <u class="text-uppercase"> {{ expandText }}</u>
              <CIcon :class="item._expanded ? 'invert-icon' : ''" name="arrow" class="mx-1" size="custom-size" :height="15" viewBox="0 0 32 32" />
            </span>
          </td>
        </template>

        <template #details="{item}">
          <CCollapse :show="Boolean(item._expanded)">
            <slot name="expanded-area" :item="removeFieldNewField(item)"></slot>
          </CCollapse>
        </template>
      </CDataTable>
    </CCardBody>

    <div v-if="pagination">
      <CPagination
        v-show="totalPages > 0"
        :pages="totalPages"
        class="dataTable__pagination"
        :class="{ [$style.blockClick]: this.loading }"
        :doubleArrows="false"
        :active-page="currentPage"
        @update:activePage="updatePagination"
        ref="pagination"
      >
        <template slot="previous-button">
          <span class="pagination__button p-2">
            <i class="icon fas fa-angle-left font-weight-light fa-2x text-gray-500"></i>
          </span>
        </template>

        <template slot="next-button">
          <span class="pagination__button p-2">
            <i class="icon fas fa-angle-right font-weight-light fa-2x text-gray-500"></i>
          </span>
        </template>
      </CPagination>

      <div v-if="totalPages > 1" class="page-item d-flex justify-content-center paginationDetail-position text-gray-600">
        {{ currentPage }} of {{ totalPages }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SenditTable',
  props: {
    // ? Registros que irão ser listados
    registers: {
      type: Array,
      default: [],
    },
    // ? Cabeçalho da tabela
    headers: {
      type: Array,
      default: [],
    },
    // ? Exibe o loading da tabela
    loading: {
      type: Boolean,
      default: false,
    },
    // ? Diz se a tabela tem paginação ou não
    pagination: {
      type: Boolean,
      default: false,
    },
    // ? Quantidade de itens por página
    itemsPerPage: {
      type: Number,
      default: 10, // Valor que normalmente é usado ao longo da aplicação
    },
    // ? Página que está selecionada
    currentPage: {
      type: Number,
      default: 0,
    },
    // ? Total de páginas
    totalPages: {
      type: Number,
      default: 0,
    },
    // ? Total de registros
    totalRecords: {
      type: Number,
      default: 0,
    },
    // ? Diz se poderá haver seleção de linhas
    selectable: {
      type: Boolean,
      default: false,
    },
    // ? Tipo de seleção de linhas
    selectionType: {
      type: String,
      default: 'checkbox', // checkbox ou radio
    },
    // ? Pode expandir a o contúdo da linha
    expandable: {
      type: Boolean,
      default: false,
    },
    // ? Texto utilizado na mensagem que irá expandir
    expandText: {
      type: String,
      default: 'Details',
    },
    // ? Diz se é possível realizar buscas na tabela
    searchable: {
      type: Boolean,
      default: false,
    },
    // ? Texto que irá no placeholder do campo de pesquisa
    searchPlaceholder: {
      type: String,
      default: 'Search',
    },
    // ? Tempo de intervalo entre o tempo que o ultimo caractere foi digitado e o início da busca
    searchTime: {
      type: Number,
      default: 1500,
    },
  },
  data() {
    return {
      headersData: [],
      registersData: [],
      selectedRegisters: [],
      searchTimeout: null,
      searchValue: '',
    }
  },
  methods: {
    updatePagination(currentPage) {
      this.$emit('updatePage', currentPage)
    },

    // Início Funções de seleção de linhas
    selectRegister() {
      this.selectedRegisters = []
      let registers = JSON.parse(JSON.stringify(this.registersData.filter(elm => elm._selected)))
      this.selectedRegisters = this.removeAuxFields(registers)
      let result = JSON.parse(JSON.stringify(this.selectedRegisters))
      this.$emit('selectRow', result)
    },
    selectRegisterRadio(value) {
      this.selectedRegisters = []
      this.registersData.forEach(elm => (elm._selected = false))
      let registers = [JSON.parse(JSON.stringify(value))]
      this.selectedRegisters = this.removeAuxFields(registers)
      let result = JSON.parse(JSON.stringify(this.selectedRegisters))
      this.$emit('selectRow', result)
    },
    selectAllRegisters(value) {
      this.registersData.forEach(elm => (elm._selected = value))
      this.selectedRegisters = []
      let registers = JSON.parse(JSON.stringify(this.registersData.filter(elm => elm._selected)))
      this.selectedRegisters = this.removeAuxFields(registers)
      let result = JSON.parse(JSON.stringify(this.selectedRegisters))
      this.$emit('selectRow', result)
    },
    // Fim Funções de seleção de linhas

    // Início das funções de expandir
    toggleDetails(item, index) {
      item._expanded = !item._expanded
    },
    // Fim das funções de expandir

    // Início das funções de busca
    search() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout)
      }

      this.searchTimeout = setTimeout(() => {
        this.$emit('search', this.searchValue)
      }, this.searchTime)
    },
    // Fim das funções de busca

    removeAuxFields(array) {
      return array.map(elm => {
        return this.removeField(elm)
      })
    },

    removeField(field) {
      delete field._selected
      delete field._expanded
      return field
    },

    removeFieldNewField(campo) {
      let field = JSON.parse(JSON.stringify(campo))
      delete field._selected
      delete field._expanded
      return field
    },
  },
  created() {
    let headersTemp = JSON.parse(JSON.stringify(this.headers))
    let registersTemp = JSON.parse(JSON.stringify(this.registers))

    if (this.selectable) {
      headersTemp.unshift({
        key: 'select',
        label: '',
        _classes: 'hidde',
        _style: 'width:50px',
      })

      registersTemp.forEach(elm => {
        elm._selected = false
      })
    }

    if (this.expandable) {
      headersTemp.push({
        key: 'expand-column',
        label: '',
        _classes: 'hidde',
        _style: 'width:50px',
      })

      registersTemp.forEach(elm => {
        elm._expanded = false
      })
    }

    this.headersData = headersTemp
    this.registersData = registersTemp
  },
}
</script>

<style scoped>
.paginationDetail-position {
  transform: translateY(-50px);
  width: 50%;
  margin: 0 auto;
}

.action-filters-area {
  min-height: 60px;
}

.invert-icon {
  transform: rotate(180deg);
}

.separator {
  border-bottom: 1px solid #7f889a;
}

.iconSearchPlaceholder-table::after {
  content: '\f002';
  font-size: 20px;
  top: calc(100% - 50px);
  width: 50px;
  color: var(--gray-700);
  text-align: center;
  line-height: 50px;
  position: absolute;
  display: inline;
  font-family: 'Font Awesome 5 Pro';
  font-weight: 300;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1;
}
</style>

<style module>
.blockClick {
  pointer-events: none;
}
</style>
